export const DIGITAL_DISPATCH_NETWORK_TOWBOOK = 'TowBook';
export const DIGITAL_DISPATCH_NETWORK_TOWMAGIC = 'TowMagic';
export const DIGITAL_DISPATCH_NETWORK_ANALOG = 'Analog';
export const DIGITAL_DISPATCH_NETWORK_ISSC = 'ISSC';

/**
 * Maps returned digital application type values from provider selection algorithm resultset
 * to the standardized application names we use for this application and the logging tables
 */
export const PROVIDER_RESULTS_DIGIAL_APPLICATION_NAME_TO_NORMALIZED_DIGITAL_APPLICATION_NAME = {
  TOWBOOK: DIGITAL_DISPATCH_NETWORK_TOWBOOK,
  BEACONSOFT: DIGITAL_DISPATCH_NETWORK_TOWMAGIC,
  ISCWEBSERVICE: DIGITAL_DISPATCH_NETWORK_ISSC,
  TOWMAGIC: DIGITAL_DISPATCH_NETWORK_TOWMAGIC,
};
